import * as React from "react";
import { forwardRef } from "react";
const SvgArrow = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 9.919, height: 5.857, ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0 .976a.97.97 0 0 1 .291-.69 1 1 0 0 1 1.4 0L4.959 3.5 8.226.286a1 1 0 0 1 1.4 0 .965.965 0 0 1 0 1.38l-3.968 3.9a1 1 0 0 1-1.4 0L.29 1.666A.97.97 0 0 1 0 .976" }));
const ForwardRef = forwardRef(SvgArrow);
export { ForwardRef as ReactComponent };
